import { MaxPerUserInputField } from './views/MaxPerUserInputField';
import { AbstractFieldGroupView } from './base/AbstractFieldGroupView';
import { QuantityLimitInputField, QuantityLimitInputValue } from './views/QuantityLimitInputField';
import { isDate, isNumber, isUndefined } from '@fxts/core';
import { SaleEndDateInputField } from './views/SaleEndDateInputField';
import { SaleStartDateInputField } from './views/SaleStartDateInputField';

export type ProductEditorFieldType = '한정판매수량' | '인당구매수량제한' | '판매시작일' | '판매종료일';

export class ProductEditorFieldFactory {
  public static create(type: '한정판매수량', value?: QuantityLimitInputValue): QuantityLimitInputField;
  public static create(type: '인당구매수량제한', value?: number): MaxPerUserInputField;
  public static create(type: '판매시작일', value?: Date): SaleStartDateInputField;
  public static create(type: '판매종료일', value?: Date): SaleEndDateInputField;

  public static create(
    type: ProductEditorFieldType,
    value?: number | Date | QuantityLimitInputValue,
  ): AbstractFieldGroupView<unknown> {
    if (type === '한정판매수량') {
      if (QuantityLimitInputField.validateValue(value)) {
        return new QuantityLimitInputField({ value });
      } else {
        return new QuantityLimitInputField({ value: undefined });
      }
    } else if (type === '인당구매수량제한') {
      if (isNumber(value) || isUndefined(value)) {
        return new MaxPerUserInputField({ value });
      }
      throw new TypeError(
        `ProductEditorFieldFactory: Expected number for type 'number', but received ${typeof value}`,
      );
    } else if (type === '판매시작일') {
      if (isDate(value) || isUndefined(value)) {
        return new SaleStartDateInputField({ value });
      }
      throw new TypeError(
        `ProductEditorFieldFactory: Expected date for type 'date', but received ${typeof value}`,
      );
    } else if (type === '판매종료일') {
      if (isDate(value) || isUndefined(value)) {
        return new SaleEndDateInputField({ value });
      }
      throw new TypeError(
        `ProductEditorFieldFactory: Expected date for type 'date', but received ${typeof value}`,
      );
    }

    throw new Error(`ProductEditorFieldFactory: Unsupported type ${type}`);
  }
}
